import { DocumentRequestList } from './document-request-list'
import { Suspense } from 'react'
import { Stack, Skeleton } from '@mui/material'
import { PageHeader } from '@/components'

export function MonthlyDocumentsPage() {
  return (
    <>
      <PageHeader>Documentos mensais</PageHeader>
      <Suspense fallback={<DocumentRequestListLoading />}>
        <DocumentRequestList />
      </Suspense>
    </>
  )
}

const DocumentRequestListLoading = () => {
  return (
    <Stack spacing={1}>
      {Array.from({ length: 2 }).map((_, i) => (
        <Stack key={i} spacing={1}>
          <Skeleton sx={{ fontSize: 24 }} width={70} />

          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} variant="rounded" height={50} />
          ))}
        </Stack>
      ))}
    </Stack>
  )
}
